import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchWidthDistGraph = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();
    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/width_dist/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchWidthDistGraphData(graphVar) {
    return useQuery(["widthDistGraph", graphVar], () => fetchWidthDistGraph(graphVar), {
        enabled: !!(graphVar?.plateId && graphVar?.wellId),
        onError: (error) => console.log({ error }),
        refetchOnWindowFocus: false,
    });
}
